import Vuex from "vuex";
import { AppState, app } from "./app/app.module";
import { AuthState, auth } from "./auth/auth.module";
import { PanelState, panel } from "./panel/panel.module";
import { PlatformLogsState, platformLogs } from "./platformLogs/platformLogs.module";

export interface RootState {
    app: AppState;
    auth: AuthState;
    panel: PanelState;
    platformLogs: PlatformLogsState;
}

export default new Vuex.Store<RootState>({
    modules: { app, auth, panel, platformLogs },
});
